// Display labels for agent tool names used in list chips.
//
// Default label is derived from the snake_case tool name via
// title-casing. `TOOL_LABEL_OVERRIDES` holds labels that don't follow
// the default pattern (e.g. `form_fields` → "Generate Form Fields").

export const TOOL_LABEL_OVERRIDES = {
  form_fields: "Generate Form Fields",
};

export function formatToolNameAsLabel(toolName) {
  return String(toolName || "")
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function getToolLabel(toolName) {
  const label =
    TOOL_LABEL_OVERRIDES[toolName] || formatToolNameAsLabel(toolName);
  return label.toLowerCase();
}
